import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Box, Stack } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import InsightsIcon from '@mui/icons-material/Insights';
import PsychologyIcon from '@mui/icons-material/Psychology';
import RouterIcon from '@mui/icons-material/Router';
import SecurityIcon from '@mui/icons-material/Security';
import SchoolIcon from '@mui/icons-material/School';
import VideocamIcon from '@mui/icons-material/Videocam';

const serviceData = [
  {
    title: 'Siber Güvenlik Çözümleri',
    description:
      'Kurumsal varlıklarınızı siber tehditlere karşı koruyacak ağ, veri, uç nokta ve bulut güvenliği çözümlerini birlikte planlıyoruz.',
    icon: SecurityIcon,
    color: '#59d0ff',
    eyebrow: 'Dijital Koruma',
    features: [
      'Ağ Güvenliği',
      'Kimlik ve Erişim',
      'Uç Nokta Güvenliği',
      'Veri Güvenliği',
      'Bulut Güvenliği',
      'Güvenlik Yönetimi',
    ],
  },
  {
    title: 'KVKK ve Bilgi Güvenliği Danışmanlığı',
    description:
      'KVKK ve bilgi güvenliği standartlarına uyum için veri envanteri, risk analizi, politika ve süreç danışmanlığı sağlıyoruz.',
    icon: AdminPanelSettingsIcon,
    color: '#8fe1ff',
    eyebrow: 'Uyum Yönetimi',
    features: [
      'KVKK Uyum Süreçleri',
      'Veri Envanteri',
      'Risk Değerlendirmesi',
      'Politika Geliştirme',
      'Aydınlatma Metinleri',
      'Saklama ve İmha',
    ],
  },
  {
    title: 'Netsis ERP Çözümleri',
    description:
      'İşletmenizin operasyonlarını entegre eden Netsis ERP kurulum, entegrasyon, kullanıcı eğitimi ve destek süreçlerini yürütüyoruz.',
    icon: DashboardCustomizeIcon,
    color: '#35b8ea',
    eyebrow: 'Operasyon Verimliliği',
    features: ['Netsis Kurulumu', 'Entegrasyon', 'Kullanıcı Eğitimi', 'Teknik Destek'],
  },
  {
    title: 'Data Engineering & BI',
    description:
      'Farklı sistemlerden gelen veriyi güvenilir akışlara dönüştürüp dashboard, KPI ve karar destek raporlarına hazır hale getiriyoruz.',
    icon: InsightsIcon,
    color: '#2dd4bf',
    eyebrow: 'Data ve Raporlama',
    features: ['ETL/ELT Akışları', 'Veri Entegrasyonu', 'Dashboardlar', 'KPI Raporları'],
  },
  {
    title: 'AI Solutions & Analytics',
    description:
      'İş süreçlerine entegre yapay zeka ve analitik çözümleriyle veriyi yorumlayan, tahminleyen ve içgörü üreten sistemler geliştiriyoruz.',
    icon: PsychologyIcon,
    color: '#a5f3fc',
    eyebrow: 'Yapay Zeka',
    features: ['Tahminleme', 'Sınıflandırma', 'Doküman Analizi', 'AI İçgörüler'],
  },
  {
    title: 'Sanallaştırma ve Bulut Çözümleri',
    description:
      'BT altyapınızı esnek, ölçeklenebilir ve daha verimli hale getiren sanallaştırma, bulut geçişi ve felaket kurtarma çözümleri sunuyoruz.',
    icon: CloudQueueIcon,
    color: '#22d3ee',
    eyebrow: 'Modern Altyapı',
    features: ['Sunucu Sanallaştırma', 'Bulut Migrasyonu', 'Hibrit Bulut', 'Felaket Kurtarma'],
  },
  {
    title: 'Güvenlik Kamera Sistemleri',
    description:
      'İşletmenizin fiziksel güvenliği için IP kamera, kayıt sistemi, video analiz ve termal görüntüleme çözümlerini projelendiriyoruz.',
    icon: VideocamIcon,
    color: '#38bdf8',
    eyebrow: 'Fiziksel Güvenlik',
    features: ['IP Kamera Sistemleri', 'Kayıt Sistemleri', 'Video Analiz', 'Termal Görüntüleme'],
  },
  {
    title: 'Network Altyapı',
    description:
      'Kablolu ve kablosuz ağlarınız için performanslı, güvenli ve sürdürülebilir network altyapısı kurulumları yapıyoruz.',
    icon: RouterIcon,
    color: '#60a5fa',
    eyebrow: 'Kesintisiz İletişim',
    features: ['Yapısal Kablolama', 'Kablosuz Ağlar', 'Ağ Güvenliği', 'Performans Optimizasyonu'],
  },
  {
    title: 'Eğitim Programları',
    description:
      'Çalışan farkındalığı, iç prosedürlerin uygulanması ve ekiplerin sorumluluk alanlarını netleştiren KVKK ve bilgi güvenliği eğitimleri sunuyoruz.',
    icon: SchoolIcon,
    color: '#7dd3fc',
    eyebrow: 'Farkındalık',
    features: ['KVKK Farkındalığı', 'Bilgi Güvenliği', 'Prosedür Uygulama', 'Rol Bazlı Eğitim'],
  },
];

const Services = () => {
  return (
    <Box
      sx={{
        pt: { xs: 5, md: 7 },
        pb: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '-10%',
          width: 420,
          height: 420,
          background: 'radial-gradient(circle, rgba(89, 208, 255, 0.18) 0%, transparent 72%)',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '-12%',
          right: '-8%',
          width: 360,
          height: 360,
          background: 'radial-gradient(circle, rgba(38, 84, 146, 0.28) 0%, transparent 70%)',
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Stack spacing={2} sx={{ mb: { xs: 4.5, md: 5 }, maxWidth: 760 }}>
          <Typography
            sx={{
              color: 'primary.main',
              fontSize: '0.95rem',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
            }}
          >
            Hizmetlerimiz
          </Typography>
          <Typography variant="h2" component="h2">
            Güvenlikten altyapıya kurumsal teknoloji hizmetleri
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Kurumsal ihtiyaçlarınıza yönelik güvenlik, uyumluluk, altyapı ve operasyon çözümlerini
            tek bir plan içinde ele alıyoruz. Amaç, kurumunuzun hem bugününü koruyan hem de
            büyümesini destekleyen sürdürülebilir bir teknoloji yapısı kurmak.
          </Typography>
        </Stack>

        <Grid container spacing={3}>
          {serviceData.map((service) => (
            <Grid item xs={12} sm={6} lg={4} key={service.title}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.35s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    borderColor: 'rgba(89, 208, 255, 0.32)',
                    boxShadow: '0 32px 70px rgba(8, 15, 34, 0.6)',
                  },
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '220px',
                    height: '220px',
                    background: `radial-gradient(circle at 100% 0%, ${service.color}30 0%, transparent 72%)`,
                    borderRadius: '0 0 0 100%',
                  }}
                />

                <CardContent sx={{ p: { xs: 3, md: 3.5 }, flex: 1, zIndex: 1 }}>
                  <Typography
                    sx={{
                      color: service.color,
                      fontSize: '0.8rem',
                      fontWeight: 700,
                      letterSpacing: 0,
                      textTransform: 'uppercase',
                      mb: 2.5,
                    }}
                  >
                    {service.eyebrow}
                  </Typography>

                  <Box
                    sx={{
                      display: 'inline-flex',
                      p: 1.45,
                      borderRadius: '18px',
                      bgcolor: `${service.color}12`,
                      border: `1px solid ${service.color}25`,
                      color: service.color,
                      mb: 3,
                    }}
                  >
                    <service.icon sx={{ fontSize: 40 }} />
                  </Box>

                  <Typography
                    variant="h5"
                    component="h3"
                    gutterBottom
                    sx={{ color: 'text.primary', fontWeight: 700, minHeight: { md: 64 } }}
                  >
                    {service.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ lineHeight: 1.75, mb: 3 }}
                  >
                    {service.description}
                  </Typography>

                  <Grid container spacing={1.25}>
                    {service.features.map((feature) => (
                      <Grid item xs={12} sm={6} key={feature}>
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="flex-start"
                          sx={{
                            color: 'rgba(248, 251, 255, 0.82)',
                            fontSize: '0.86rem',
                            lineHeight: 1.45,
                          }}
                        >
                          <CheckCircleOutlineIcon
                            sx={{ color: service.color, fontSize: 18, mt: '1px', flexShrink: 0 }}
                          />
                          <Typography component="span" sx={{ fontSize: '0.86rem', lineHeight: 1.45 }}>
                            {feature}
                          </Typography>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
